"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var rql_1 = require("../rql");
var bind_1 = require("../bind");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("../tracker");
var signup_signin_modal_1 = require("../components/signup_signin_modal");
var user_context_provider_1 = require("../components/user_context_provider");
var modal_1 = require("../components/modal");
var offer_create_form_1 = require("./offer_create_form");
var mparticle_tracker_1 = require("../elog/mparticle_tracker");
var nudge_manager_1 = require("../nudge_manager");
var COMPONENT_NAME = 'CreateOfferButton';
var CreateOfferButton = /** @class */ (function (_super) {
    tslib_1.__extends(CreateOfferButton, _super);
    function CreateOfferButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            openDialog: false,
        };
        return _this;
    }
    CreateOfferButton.prototype.toggleModal = function (e) {
        var _this = this;
        // When handle closing the modal, it will blow up because there is no event being passed in
        // so we have to guard
        e.preventDefault();
        e.stopPropagation();
        this.setState(function (state) { return ({ openDialog: !state.openDialog }); }, function () {
            if (_this.state.openDialog) {
                _this.props.tracking.trackEvent({
                    eventType: tracker_1.INTERACTION,
                    mParticleInteraction: {
                        eventName: mparticle_tracker_1.MParticleEventName.ClickedOfferButton,
                        listingId: _this.props.listingId,
                        listing: _this.props.listing,
                        position: _this.props.position,
                        componentName: _this.props.parentComponentName,
                    },
                });
            }
        });
    };
    CreateOfferButton.prototype.handleClose = function () {
        this.setState({ openDialog: false });
    };
    CreateOfferButton.prototype.handleSuccess = function (negotiation) {
        this.handleClose();
        var otherParty = negotiation.lastOffer.initiatingParty === rql_1.core_apimessages_NegotiationParty.BUYER ?
            I18n.t('commons.offers.seller') :
            I18n.t('commons.offers.buyer');
        var initialOfferMessage = I18n.t('commons.offers.initialSubmissionSuccess', {
            otherParty: otherParty,
            amount: negotiation.lastOffer.prices.totalPrice.display.display,
        });
        if (this.props.onOfferSuccess) {
            this.props.onOfferSuccess(initialOfferMessage);
        }
    };
    CreateOfferButton.prototype.getThumbnail = function () {
        return lodash_1.get(this.props.listing, 'card_square_images[0].source', this.props.listingThumbnail);
    };
    CreateOfferButton.prototype.renderOfferSignupCallout = function () {
        if (!this.getThumbnail()) {
            return null;
        }
        return (React.createElement("div", { className: "alert-box alert-box--orange mb-2 mobile-size-90" },
            React.createElement("h4", { className: "align-center size-110 weight-bold mb-1" }, I18n.t('commons.offers.benefits.title')),
            React.createElement("div", { className: "d-flex fx-align-center" },
                React.createElement("img", { src: this.getThumbnail(), className: "width-20 mr-1" }),
                React.createElement("ul", { className: "fa-ul size-90" },
                    React.createElement("li", null,
                        React.createElement("span", { className: "fa fa-check fa-li color-green" }),
                        I18n.t('commons.offers.benefits.saveMoney')),
                    React.createElement("li", null,
                        React.createElement("span", { className: "fa fa-check fa-li color-green" }),
                        I18n.t('commons.offers.benefits.quickResponse'))))));
    };
    CreateOfferButton.prototype.renderNudge = function () {
        if (!this.props.enableNudge)
            return null;
        var nudgeText = nudge_manager_1.getOfferNudgeText(this.props.user);
        if (!nudgeText)
            return null;
        return (React.createElement("div", { className: "offer-action__nudge" }, nudgeText));
    };
    CreateOfferButton.prototype.renderSignupSigninModalOrOfferModal = function () {
        if (this.props.user.loggedOut) {
            return (React.createElement(signup_signin_modal_1.default, { active: this.state.openDialog, onRequestClose: this.handleClose, trackSource: "Offer", messageComponent: this.renderOfferSignupCallout() }));
        }
        return (React.createElement(modal_1.default, { onRequestClose: this.handleClose, isOpen: this.state.openDialog, headerTitle: I18n.t('commons.offers.action.create'), paddedBody: true, newClose: true },
            React.createElement(offer_create_form_1.default, { listingId: this.props.listingId, isSeller: this.props.isSeller, shopChannel: rql_1.core_apimessages_Channel.REVERB, onSuccess: this.handleSuccess, onCancel: this.handleClose, isDisplayed: this.state.openDialog, showNewOfferNudge: true })));
    };
    CreateOfferButton.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("button", { className: "offer-action", "data-disabled": this.props.disabled || null, onClick: this.toggleModal, type: "button" }, I18n.t('commons.offers.action.create')),
            this.renderSignupSigninModalOrOfferModal(),
            this.renderNudge()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], CreateOfferButton.prototype, "toggleModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], CreateOfferButton.prototype, "handleClose", null);
    tslib_1.__decorate([
        bind_1.default
    ], CreateOfferButton.prototype, "handleSuccess", null);
    CreateOfferButton = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.LISTING_TYPE,
                entityId: props.listingId,
            };
        })
    ], CreateOfferButton);
    return CreateOfferButton;
}(React.Component));
exports.CreateOfferButton = CreateOfferButton;
exports.default = user_context_provider_1.withUserContext(CreateOfferButton);
//# sourceMappingURL=create_offer_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/create_offer_button.js
// module id = ADfg
// module chunks = 20 21